import http from '../http'


/**
 * 分页查询所有单位信息
 * @param {Object} params 查询参数
 * @param {Number} [params.page] - 页码（从0开始）
 * @param {Number} [params.size] - 每页数量
 * @param {String} [params.sortBy] - 排序字段
 * @param {String} [params.sortDir] - 排序方向（asc/desc）
 * @param {String} [params.unitName] - 单位名称(可选，支持模糊查询)
 * @param {String} [params.contactPerson] - 联系人(可选，支持模糊查询)
 * @param {String} [params.phone] - 联系电话(可选，支持模糊查询)
 * @returns {Promise} 返回单位信息列表和分页信息
 */
export function query_unit_pagination(params = {}) {
  return http.get('/units/page', { params })
}

/**
 * 分页查询指定类型的单位信息
 * @param {Object} params 查询参数
 * @param {String} [params.unit_name] - 单位名称(可选，支持模糊查询)
 * @param {String} [params.unit_type] - 单位类型(可选，"供应商"或"客户")
 * @param {Number} [params.user_id] - 创建者ID(可选)
 * @param {Number} [params.page] - 当前页码(可选，用于分页查询)
 * @param {Number} [params.pageSize] - 每页记录数(可选，用于分页查询)
 * @returns {Promise} 返回单位信息列表和分页信息
 */
export function query_unit_pagination_by_type(params = {}) {
  return http.get('/unit-collections', { params })
}

/**
 * 获取指定ID的单位详细信息
 * @param {Number|String} id - 单位ID
 * @returns {Promise} 返回单位详细信息
 */
export function query_unit_by_id(id) {
  return http.get(`/units/${id}`)
}

/**
 * 保存新增或编辑的单位信息
 * @param {Object} data 单位信息数据
 * @param {Number} [data.id] - 单位ID(更新时必填，新增时不填)
 * @param {String} data.unit_name - 单位名称(必填)
 * @param {String} [data.contact_person] - 联系人(可选)
 * @param {String} [data.phone] - 联系电话(可选)
 * @param {String} [data.tax_id] - 税号(可选)
 * @param {String} [data.address] - 单位地址(可选)
 * @param {String} [data.bank_name] - 开户银行(可选)
 * @param {String} [data.bank_account] - 银行账号(可选)
 * @returns {Promise} 返回保存结果
 */
export function save_unit_info(data) {
  return http.post('/units', data)
}

/**
 * 删除指定ID的单位信息(逻辑删除)
 * @param {Number|String} id - 单位ID
 * @returns {Promise} 返回删除结果
 */
export function delete_unit_by_id(id) {
  return http.delete(`/units/${id}`)
}

/**
 * 获取指定ID的单位类型详细信息
 * @param {Number|String} id - 单位类型ID
 * @returns {Promise} 返回单位类型详细信息，包括关联的单位信息和创建者信息
 */
export function query_unit_type_by_id(id) {
  return http.get(`/unit-collections/${id}`)
}

/**
 * 保存单位类型信息（新增或更新）
 * @param {Object} data 单位类型信息数据
 * @param {Number} [data.id] - 单位类型ID（更新时必填，新增时不填）
 * @param {Number} data.unit_id - 关联的单位ID（必填）
 * @param {String} data.unit_type - 单位类型，只能是"供应商"或"客户"（必填）
 * @param {Number} [data.user_id] - 创建者ID，不填则取当前登录用户ID
 * @returns {Promise} 返回保存结果
 */
export function save_unit_type(data) {
  return http.post('/unit-collections', data)
}

/**
 * 随机选择一个单位并保存为新的单位类型
 * @description 自动从单位信息表中随机选择一个单位ID和类型（供应商或客户）进行新增
 * @returns {Promise} 返回保存结果
 */
export async function save_random_new_unit_type() {
  try {
    // 1. 获取所有单位信息
const unitsResponse = await query_unit_pagination()
// 2. 从响应中提取单位列表
    let unitsList = []
    
    // 尝试各种可能的数据结构
    try {
      if (unitsResponse.data && unitsResponse.data.items && Array.isArray(unitsResponse.data.items)) {
unitsList = unitsResponse.data.items
      } else if (unitsResponse.data && unitsResponse.data.data && Array.isArray(unitsResponse.data.data)) {
unitsList = unitsResponse.data.data
      } else if (unitsResponse.data && unitsResponse.data.data && unitsResponse.data.data.items && Array.isArray(unitsResponse.data.data.items)) {
unitsList = unitsResponse.data.data.items
      } else if (unitsResponse.data && unitsResponse.data.data && unitsResponse.data.data.list && Array.isArray(unitsResponse.data.data.list)) {
unitsList = unitsResponse.data.data.list
      } else if (unitsResponse.data && Array.isArray(unitsResponse.data)) {
unitsList = unitsResponse.data
      } else {
        // 尝试手动创建一些测试单位数据
unitsList = [
          {
            id: 1,
            unit_name: '测试单位1',
            contact_person: '联系人1',
            phone: '13800000001'
          },
          {
            id: 2,
            unit_name: '测试单位2',
            contact_person: '联系人2',
            phone: '13800000002'
          }
        ]
      }
    } catch (parseError) {
      console.error('解析单位数据出错:', parseError)
      // 使用模拟数据作为备选
      unitsList = [
        {
          id: 1,
          unit_name: '备选测试单位1',
          contact_person: '联系人1',
          phone: '13800000001'
        }
      ]
    }
    
// 3. 确保有可用的单位
    if (!unitsList || !unitsList.length) {
      console.error('没有可用的单位信息')
      return Promise.reject({
        data: {
          success: false,
          message: '没有可用的单位信息，无法创建单位类型',
          details: unitsResponse && unitsResponse.data ? JSON.stringify(unitsResponse.data) : '无响应数据'
        }
      })
    }
    
    // 4. 随机选择一个单位
    const randomUnit = unitsList[Math.floor(Math.random() * unitsList.length)]
// 确保单位有ID
    const unitId = randomUnit.id || randomUnit.unit_id
    if (!unitId) {
      console.error('随机选择的单位没有ID')
      return Promise.reject({
        data: {
          success: false,
          message: '单位数据结构异常，未找到ID字段',
          details: JSON.stringify(randomUnit)
        }
      })
    }
    
    // 5. 随机选择一个类型（供应商或客户）
    const types = ['供应商', '客户']
    const randomType = types[Math.floor(Math.random() * types.length)]
    
    // 6. 构建新的单位类型数据
    const newUnitTypeData = {
      unit_id: unitId,
      unit_type: randomType
    }
    
// 7. 保存单位类型
    return save_unit_type(newUnitTypeData)
  } catch (error) {
    console.error('保存随机单位类型失败:', error)
    return Promise.reject({
      data: {
        success: false,
        message: '查询单位信息失败: ' + (error.message || '未知错误'),
        error: error.toString(),
        stack: error.stack
      }
    })
  }
}

/**
 * 随机选择一个现有单位类型并更新其类型
 * @description 自动从单位类型表中随机选择一条记录，并将其类型更改为相反的值（供应商变客户，客户变供应商）
 * @returns {Promise} 返回更新结果
 */
export async function update_random_unit_type() {
  try {
    // 1. 获取所有单位类型信息
    const typeResponse = await query_unit_pagination_by_type()
    
    // 2. 从响应中提取单位类型列表
    let typesList = []
    
    if (typeResponse.data && typeResponse.data.data) {
      typesList = typeResponse.data.data.items || typeResponse.data.data.records || typeResponse.data.data
    } else if (typeResponse.data && Array.isArray(typeResponse.data.items)) {
      typesList = typeResponse.data.items
    } else if (Array.isArray(typeResponse.data)) {
      typesList = typeResponse.data
    }
    
    // 3. 确保有可用的单位类型
    if (!typesList.length) {
      return Promise.reject({
        data: {
          success: false,
          message: '没有可用的单位类型信息，无法进行更新'
        }
      })
    }
    
    // 4. 随机选择一个单位类型记录
    const randomUnitType = typesList[Math.floor(Math.random() * typesList.length)]
    
    // 5. 将类型更改为相反的值
    const newType = randomUnitType.unit_type === '供应商' ? '客户' : '供应商'
    
    // 6. 构建更新数据
    const updateData = {
      id: randomUnitType.id,
      unit_id: randomUnitType.unit_id,
      unit_type: newType
    }
    
    // 7. 更新单位类型
    return save_unit_type(updateData)
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * 删除指定ID的单位类型
 * @param {Number|String} id - 单位类型ID
 * @returns {Promise} 返回删除结果
 */
export function del_unit_type(id) {
  return http.delete(`/unit-collections/${id}`)
}

/**
 * 获取单位列表（兼容函数，内部调用query_unit_pagination）
 * @param {Object} params 查询参数
 * @returns {Promise} 返回单位信息列表和分页信息
 */
export function getUnitList(params = {}) {
  return query_unit_pagination(params)
}

/**
 * 根据类型获取单位列表
 * @param {String} unit_type - 单位类型（例如"客户"、"供应商"）
 * @param {String|Number} create_id - 创建者ID
 * @returns {Promise} 返回单位列表
 */
export function get_units_by_type(unit_type, create_id) {
  // 始终发送单位类型和创建者ID作为参数
  const params = { 
    unit_type,
    create_id 
  };
  
return http.get('/unit-collections/units-by-type', { params });
}

/**
 * 获取所有单位信息
 * @returns {Promise} 返回所有有效的单位信息列表
 */
export function getAllUnits() {
  return http.get('/units')
}

/**
 * 获取指定单位的供应商列表（分页）
 * @param {Number|String} unitId - 单位ID
 * @param {Object} params - 查询参数
 * @param {Number} [params.page=0] - 页码（从0开始）
 * @param {Number} [params.size=10] - 每页数量
 * @param {String} [params.sortBy='id'] - 排序字段
 * @param {String} [params.sortDir='desc'] - 排序方向（asc/desc）
 * @param {String} [params.unitName] - 供应商单位名称（模糊匹配）
 * @param {String} [params.contactPerson] - 供应商联系人姓名（模糊匹配）
 * @param {String} [params.phone] - 供应商联系电话（模糊匹配）
 * @returns {Promise} 返回供应商列表和分页信息
 */
export function getSuppliersByUnitId(unitId, params = {}) {
  return http.get(`/units/${unitId}/suppliers`, { params })
}

/**
 * 为指定单位添加供应商关系
 * @param {Number|String} unitId - 单位ID
 * @param {Number|String} supplierId - 供应商单位ID
 * @returns {Promise} 返回添加结果
 */
export function addSupplier(unitId, supplierId) {
  return http.post(`/units/${unitId}/suppliers/${supplierId}`)
}

/**
 * 删除指定单位的供应商关系
 * @param {Number|String} unitId - 单位ID
 * @param {Number|String} supplierId - 供应商单位ID
 * @returns {Promise} 返回删除结果
 */
export function removeSupplier(unitId, supplierId) {
  return http.delete(`/units/${unitId}/suppliers/${supplierId}`)
}

/**
 * 获取指定单位的客户列表（分页）
 * @param {Number|String} unitId - 单位ID
 * @param {Object} params - 查询参数
 * @param {Number} [params.page=0] - 页码（从0开始）
 * @param {Number} [params.size=10] - 每页数量
 * @param {String} [params.sortBy='id'] - 排序字段
 * @param {String} [params.sortDir='desc'] - 排序方向（asc/desc）
 * @param {String} [params.unitName] - 客户单位名称（模糊匹配）
 * @param {String} [params.contactPerson] - 客户联系人姓名（模糊匹配）
 * @param {String} [params.phone] - 客户联系电话（模糊匹配）
 * @returns {Promise} 返回客户列表和分页信息
 */
export function getCustomersByUnitId(unitId, params = {}) {
  return http.get(`/units/${unitId}/customers`, { params })
}

/**
 * 为指定单位添加客户关系
 * @param {Number|String} unitId - 单位ID
 * @param {Number|String} customerId - 客户单位ID
 * @returns {Promise} 返回添加结果
 */
export function addCustomer(unitId, customerId) {
  return http.post(`/units/${unitId}/customers/${customerId}`)
}

/**
 * 删除指定单位的客户关系
 * @param {Number|String} unitId - 单位ID
 * @param {Number|String} customerId - 客户单位ID
 * @returns {Promise} 返回删除结果
 */
export function removeCustomer(unitId, customerId) {
  return http.delete(`/units/${unitId}/customers/${customerId}`)
}

/**
 * 获取指定单位的所有供应商列表（不分页，用于下拉选单）
 * @param {Number|String} unitId - 单位ID
 * @returns {Promise} 返回所有供应商列表，适用于下拉选单等场景
 */
export function getAllSuppliersByUnitId(unitId) {
  return http.get(`/units/${unitId}/suppliers/all`)
}

/**
 * 获取指定单位的所有客户列表（不分页，用于下拉选单）
 * @param {Number|String} unitId - 单位ID
 * @returns {Promise} 返回所有客户列表，适用于下拉选单等场景
 */
export function getAllCustomersByUnitId(unitId) {
  return http.get(`/units/${unitId}/customers/all`)
}

export default {
  query_unit_pagination,
  query_unit_pagination_by_type,
  query_unit_by_id,
  save_unit_info,
  delete_unit_by_id,
  query_unit_type_by_id,
  save_unit_type,
  save_random_new_unit_type,
  update_random_unit_type,
  del_unit_type,
  getUnitList,
  get_units_by_type,
  getAllUnits,
  getSuppliersByUnitId,
  addSupplier,
  removeSupplier,
  getCustomersByUnitId,
  addCustomer,
  removeCustomer,
  getAllSuppliersByUnitId,
  getAllCustomersByUnitId
}